import { render, staticRenderFns } from "./AvatarChip.vue?vue&type=template&id=579494ec&scoped=true&"
import script from "./AvatarChip.vue?vue&type=script&lang=js&"
export * from "./AvatarChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579494ec",
  null
  
)

export default component.exports